module.exports = __webpack_public_path__ + "media/images/features/support/thumb-type-mail-d481537fa333e878356bc857ba730d67.png";